<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">{{ locale.order_limit_settings }}</h2>
      <div class="innerContent">
        <!-- 주문가능시간 -->
        <div class="mb15">
          <div class="setLabel mb5">{{ locale.available_order_time }}</div>
          <p class="sysMessage">{{ locale.message_order_time_over }}</p>
          <select class="input select sizeM mr10" v-model="orderHour">
            <option :value="0">{{ locale.not_setting }}</option>
            <option v-for="hour in 24"
              :key="hour"
              :value="hour">
              {{`${hour}${locale.hour}`}}
            </option>
          </select>
          <select class="input select sizeM" v-model="orderMinute">
            <option :value="0">{{ locale.not_setting }}</option>
            <option v-for="minute in 12"
              :key="minute * 5"
              :value="minute * 5">
              {{`${minute * 5}${locale.minute}`}}
            </option>
          </select>
        </div>
        <!-- //주문가능시간 -->
        <!-- 주문시간 임박 메시지 -->
        <div class="mb15">
          <div class="setLabel mb5">{{ locale.order_time_imminent_message }}</div>
          <p class="sysMessage">{{ locale.message_order_time_imminent }}</p>
          <select class="input select sizeM" v-model="orderableMessage">
            <option :value="0">{{ locale.not_setting }}</option>
            <option v-for="minute in 30"
              :key="minute"
              :value="minute">
              {{`${minute}${locale.minute}`}}
            </option>
          </select>
        </div>
        <!-- //주문시간 임박 메시지 -->
        <!-- 주문 대기시간 -->
        <div class="mb15">
          <div class="setLabel mb5">{{ locale.order_waiting_time }}</div>
          <p class="sysMessage">{{ locale.message_order_waiting_time }}</p>
          <select class="input select sizeM" v-model="waitingOrder">
            <option :value="0">{{ locale.not_setting }}</option>
            <option v-for="time in 30"
              :key="time"
              :value="time">
              {{`${time}${locale.minute}`}}
            </option>
          </select>
        </div>
        <!-- //주문 대기시간 -->
        <!-- 총 주문횟수 -->
        <div class="mb15">
          <div class="setLabel mb5">{{ locale.total_order_count }}</div>
          <p class="sysMessage">{{ locale.message_order_count }}</p>
          <input type="text" class="input sizeM" v-model="orderLimit" @input="inputNumber('orderLimit')">
        </div>
        <!-- //총 주문횟수 -->
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" @click="apply">{{ locale.apply }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  name: 'OrderLimit',
  props: [
    'locale',
    'defaultLang',
    'pageId'
  ],
  computed: {
    orderHour: {
      get () { return Math.floor(this.orderableTime / 60) },
      set (h) {
        const minute = this.orderableTime % 60
        this.orderableTime = Number(h) * 60 + minute
      }
    },
    orderMinute: {
      get () { return this.orderableTime % 60 },
      set (m) {
        const hour = Math.floor(this.orderableTime / 60)
        this.orderableTime = hour * 60 + Number(m)
      }
    }
  },
  async created () {
    await this.getShopOrderLimit()
  },
  data () {
    return {
      orderableTime: 0,
      orderableMessage: 0,
      waitingOrder: 0,
      orderLimit: 0
    }
  },
  methods: {
    async getShopOrderLimit () {
      const getShopOrderLimit = await this.$store.dispatch('shop/getShopOrderLimit', this.pageId)
      const orderLimit = getShopOrderLimit?.message
      
      this.orderableTime = orderLimit?.orderableTime || 0
      this.orderableMessage = orderLimit?.orderableMessage || 0
      this.waitingOrder = orderLimit?.waitingOrder || 0
      this.orderLimit = orderLimit?.orderLimit || 0
    },
    inputNumber (key) {
      const value = Number(regExp.numberOnly(this[key]))
      this[key] = value
    },
    close () {
      this.$emit('close')
    },
    async apply () {
      const data = {
        pageId: this.pageId,
        orderableTime: this.orderableTime,
        orderableMessage: this.orderableMessage,
        waitingOrder: this.waitingOrder,
        orderLimit: this.orderLimit
      }
      if (window.confirm(this.locale.confirm_apply)) {
        this.$store.commit('onLoading', true)
        const res = await this.$store.dispatch('shop/putShopOrderLimit', data)
        if (res?.status === 200) {
          alert(this.locale.complete_save)
          this.$emit('close')
        }
        this.$store.commit('onLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 400px;
  }
}
</style>
